import ClientDetailsTab from "./ClientDetailsTab";

const ClientDetails = (props) => {
  return (
    <div className="App">
      <>
        <ClientDetailsTab
          key={props.refreshKey}
          clientCode={props.clientCode}
        />
      </>
    </div>
  );
};
export default ClientDetails;
